import type {SalesRepository} from '../repository/SalesRepository';
import type {Sale} from '../models/sale.model';

export class GetSaleByInvoiceNumberUseCase {
  constructor (private salesRepository: SalesRepository) {}

  async execute (invoiceNumber: string): Promise<Sale> {
    const response = await this.salesRepository.getSaleByInvoiceNumber(invoiceNumber);

    if (response.stat_code !== 200) {
      throw new Error(response.stat_message || 'حدث خطأ في جلب تفاصيل الفاتورة');
    }

    return response.data;
  }
}
